// @flow
import idx from 'idx';
import gql from 'graphql-tag';
import * as React from 'react';
import { graphql } from 'react-apollo';
import ErrorReporter from 'app/components/ErrorReporter';
import OrganizationPageHeader from 'organizations/components/OrganizationPageHeader';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import Redirect from 'components/Redirect';

import './styles/OrganizationPage.scss';

type Props = {
  data: *,
  params: *,
  children: React.Node,
};

type State = {
  error?: Error,
};

class OrganizationPage extends React.Component<Props, State> {
  state: State = {};

  componentDidCatch(error: Error) {
    this.setState({ error });
  }

  render() {
    const { error } = this.state;
    const { data } = this.props;

    if (error) {
      return (
        <div className="OrganizationPage">
          <ErrorReporter error={error}>
            <div>Oops, an error happened: {error.toString()}</div>
            <div>
              The Remind team has been alerted and is working on the issue. Please try refreshing
              the page, if the problem persist, please contact Remind support at
              support@remindhq.com
            </div>
          </ErrorReporter>
        </div>
      );
    }

    if (data && data.loading) {
      return <CenteredLoadingIndicator />;
    }

    const organization = idx(this.props, _ => _.data.organizations[0]);

    if (!organization) {
      console.error('OrganizationPage - loaded without an organization');
      console.warn(this.props.data.error);
      return <Redirect to="/classes" />;
    }

    return (
      <div className="OrganizationPage">
        <OrganizationPageHeader
          uuid={organization.uuid}
          routePrefix={`/organizations/${this.props.params.id}`}
        />
        {this.props.children}
      </div>
    );
  }
}

const withOrganization = graphql(
  gql`
    query OrganizationPage($organizationId: Int) {
      organizations(ids: [$organizationId]) {
        uuid
        name
      }
    }
  `,
  {
    options: ({ params }) => ({ variables: { organizationId: params.id } }),
  }
);

export { OrganizationPage };
export default withOrganization(OrganizationPage);
